import { useEffect } from 'react';
import { API_CACHE_KEYS, API_PATHS } from '@/modules/common/constants';
import { useToast } from '@pw-tech/omni-ui';
import { useMutation } from '@tanstack/react-query';
import { ApiClient } from '@pw-tech/web-sdk';

const useIOIFileUpload = () => {
  const { toast: showToaster } = useToast();
  const { data, isLoading, mutate, mutateAsync, error } = useMutation(
    [API_CACHE_KEYS.UPLOAD_FILE],
    ({ file, onUploadProgress }: { file: any; onUploadProgress: (progress: number) => void }) => {
      const queryParam = {
        type: 'ADMIN',
        fileName: file?.name,
        extension: file?.name.split('.').pop(),
        contentType: file?.type,
      };
      //   const formData = new FormData();
      //   formData.append('file', file);
      onUploadProgress(60);
      //   return Client.post(API_PATHS.V1_FILES, formData, {
      return ApiClient.post(API_PATHS.UPLOAD_FILE, undefined, {
        params: queryParam,
        // headers: {
        //   'Content-Type': 'multipart/form-data',
        // },
      });
    }
  );

  useEffect(() => {
    if (error) {
      showToaster({
        message:
          typeof (error as any)?.message === 'string'
            ? (error as any).message
            : 'Error in File Upload',
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center',
        },
      });
    }
  }, [error]);

  return {
    isLoading,
    mutate,
    mutateAsync,
  };
};

export default useIOIFileUpload;
